const dynamicSizes = {
  MEDIUM_TABLET: {
    MIN_WIDTH: 561,
    MIN_HEIGHT: 265,
    MAX_WIDTH: 576,
    MAX_HEIGHT: 440,
  },
  TABLET: {
    MIN_WIDTH: 561,
    MIN_HEIGHT: 290,
    MAX_WIDTH: 706,
    MAX_HEIGHT: 564,
  },
  DESKTOP: {
    MIN_WIDTH: 785,
    MIN_HEIGHT: 440,
    MAX_WIDTH: 1201,
    MAX_HEIGHT: 712,
  },
};

function getDeviceType() {
  const width = window.innerWidth;
  if (width <= 640) {
    return 'MEDIUM_TABLET';
  }
  if (width <= 768) {
    return 'TABLET';
  }
  return 'DESKTOP';
}

export {
  getDeviceType,
  dynamicSizes,
};
